import React from 'react'
import PropTypes from 'prop-types';

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matchedSong: []
    }
  }
  onSearchChange = (event) => {
    let searchTerm = event.target.value.toLowerCase().trim();
    let count = 0;
    /*
    for(let i=0; i<searchTerm.length;i++) {
      if(searchTerm[i] === " ") {
        count++;
        if(count>=2) {
          searchTerm = searchTerm.replace("  "," ");
        }
      } else {
        count=0;
      }
    }
    */
    let similerTerms = [], currentTitle;
    if (searchTerm.length >= 3) {
      this.props.list.map((iterator) => {
        currentTitle = iterator.title.toLowerCase().trim();
        if (currentTitle.includes(searchTerm)) {
          similerTerms.push(iterator.title);
        }
        return 0;
      })
    }
    this.setState({ matchedSong: similerTerms });
  }

  render() {
    //console.log("1111", this.state.matchedSong);
    return (
      <div>
        <div className="listen-search">
          <div className="listen-search-box">
            <i class="fa fa-search" style={{ color: "inherit" }}></i>
            <input
              type="text"
              name="listenSearch"
              onChange={this.onSearchChange} />
          </div>
        </div>
        <div className="populated-list-box">
          {
            this.state.matchedSong.map((iterator) => {
              return (
                <div className="populated-list">
                  {iterator}
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }
}

SearchBar.defaultProps = {
  list: []
}


//prop types checkes
SearchBar.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object)
}


export default SearchBar